import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchLead = createAsyncThunk(
    "lead",
    async (type, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem("authToken");

            if (!token) {
                return rejectWithValue("Token not found");
            }

            const response = await axios.get(`${API_URL}/lead?type=${type}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data.data.data;
        } catch (error) {
            console.error("Error fetching leads data:", error);
            return rejectWithValue(
                error.response?.data || "Failed to fetch leads data"
            );
        }
    }
);

export const updatePIC = createAsyncThunk(
    "lead/pic",
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem("authToken");
            
            if (!token) {
                return rejectWithValue("Token not found");
            }

            const response = await axios.post(`${API_URL}/lead/pic/${items.leads_id}`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data;
        } catch (error) {
            console.error("Error update pic data:", error);
            return rejectWithValue(
                error.response?.data || "Failed to update pic data"
            );
        }
    }
);

export const confirmData = createAsyncThunk(
    'v1/confirm-testdrive', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/v1/confirm-testdrive`, item, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create item');
        }
    }
);

const leadSlice = createSlice({
    name: "leads",
    initialState: {
        leads: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchLead.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchLead.fulfilled, (state, action) => {
            state.isLoading = false;
            state.leads = action.payload;
        })
        .addCase(fetchLead.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(confirmData.fulfilled, (state, action) => {
            state.leads.push(action.payload);
        })
        .addCase(updatePIC.fulfilled, (state, action) => {
            const index = state.leads.findIndex((item) => item.leads_id === action.payload.data.leads_id);
            if (index !== -1) {
                state.leads[index] = { ...state.leads[index], ...action.payload.data };
            }
            state.isLoading = false;
        });
    },
});

export default leadSlice.reducer;
